import { styled } from '@classify/react-core-components/styles';

const HEADER_HEIGHT = 63;

export const Root = styled('div')(({ theme: { zIndex, palette, breakpoints, spacing } }) => ({
  position: 'relative',
  width: '100%',
  zIndex: zIndex.appBar,

  '& .mainHeader__headerPlaceholder': {
    visibility: 'none',
  },
  '& .MuiAppBar-root': {
    display: 'block',
    backgroundColor: palette.background.primary,
    borderBottom: `1px solid ${palette.layout.line.divider}`,
  },
  '& .mainHeader__content': {
    display: 'flex',
    alignItems: 'center',
    minHeight: HEADER_HEIGHT,
    [breakpoints.down('md')]: {
      minHeight: 55,
    },
  },
  '& .mainHeader__innerWrapper': {
    margin: spacing(0, 2),
  },
  '& .mainHeader__navWrapper': {
    display: 'none',
    [breakpoints.up('md')]: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
    },
    '& .jobSurvey &': {
      display: 'none',
    },
  },
  '& .mainHeader__linksWrapper': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  '& .mainHeader__button': {
    marginLeft: 'auto',
  },
  '& .mainHeader__actions': {
    display: 'flex',
    marginLeft: spacing(2),

    [breakpoints.down('md')]: {
      display: 'none',
    },
  },
  '& .mainHeader__action': {
    '&:not(:last-child)': {
      marginRight: spacing(2),
    },
  },
  '& .mainHeader__contentWrapper': {
    position: 'static',
  },
  '& .mainHeader__divider': {
    [breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));
